// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"4482032a","703":"e1bafe25"}[chunkId] + ".chunk.js";
};